export default __webpack_public_path__ + "static/media/r.75f90fcc.svg";